"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.hcCartInfoReducer = hcCartInfoReducer;
var _simpleDataReducer = require("../../../common/utils/simpleDataReducer");
var actions = _interopRequireWildcard(require("./actions"));
var _const = require("./const");
var _seamlessImmutable = _interopRequireDefault(require("seamless-immutable"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const getHcCartReducer = (0, _simpleDataReducer.createReducer)(actions.GET_HC_CART_API);
const updateCartReducer = (0, _simpleDataReducer.createReducer)(actions.UPDATE_CART_API);
const updateCartMapUser = (0, _simpleDataReducer.createReducer)(actions.UPDATE_CART_MAP_USER_API);
const createCart = (0, _simpleDataReducer.createReducer)(actions.CREATE_CART_API);
const deleteCart = (0, _simpleDataReducer.createReducer)(actions.DELETE_CART_API);
const deleteCartEntryNumber = (0, _simpleDataReducer.createReducer)(actions.DELETE_CART_ENTRY_NUMBER_API);
const deleteMultipleCartEntryNumber = (0, _simpleDataReducer.createReducer)(actions.DELETE_MULTIPLE_CART_ENTRY_NUMBER_API);
const getCartCount = (0, _simpleDataReducer.createReducer)(actions.GET_CART_COUNT_API);
const getCartSlot = (0, _simpleDataReducer.createReducer)(actions.GET_CART_SLOT_API);
const getIndividualCartSlot = (0, _simpleDataReducer.createReducer)(actions.GET_INDIVIDUAL_CART_SLOT_API);
const getMainCartSlot = (0, _simpleDataReducer.createReducer)(actions.GET_MAIN_CART_SLOT_API);
const getUpcomingOrders = (0, _simpleDataReducer.createReducer)(actions.GET_UPCOMING_ORDERS_API);
const getIndividualCartSlotEvery = (0, _simpleDataReducer.createReducer)(actions.GET_INDIVIDUAL_CART_SLOT_API_EVERY);
const getCompletedOrders = (0, _simpleDataReducer.createReducer)(actions.GET_COMPLETED_ORDERS_API);

/**
  cart_operation initial state
 cartInfo:{
    count:0
  }
 */
const initialState = (0, _seamlessImmutable.default)({
  cartInfo: {
    count: 0
  }
});
function hcCartInfoReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_HC_CART_INFO:
      return {
        ...state,
        ...action.data
      };
    default:
      return state;
  }
}
var _default = exports.default = {
  [_const.GET_HC_CART]: getHcCartReducer,
  [_const.UPDATE_CART]: updateCartReducer,
  [_const.UPDATE_CART_MAP_USER]: updateCartMapUser,
  [_const.CREATE_CART]: createCart,
  [_const.DELETE_CART]: deleteCart,
  [_const.DELETE_CART_ENTRY_NUMBER]: deleteCartEntryNumber,
  [_const.DELETE_MULTIPLE_CART_ENTRY_NUMBER]: deleteMultipleCartEntryNumber,
  [_const.GET_CART_COUNT]: getCartCount,
  [_const.HC_CART_INFO]: hcCartInfoReducer,
  [_const.GET_CART_SLOT]: getCartSlot,
  [_const.GET_INDIVIDUAL_CART_SLOT]: getIndividualCartSlot,
  [_const.GET_MAIN_CART_SLOT]: getMainCartSlot,
  [_const.GET_UPCOMING_ORDERS]: getUpcomingOrders,
  [_const.GET_INDIVIDUAL_CART_SLOT_EVERY]: getIndividualCartSlotEvery,
  [_const.GET_COMPLETED_ORDERS]: getCompletedOrders
}; // export const hcCartReducer = { [HC_CART_INFO]: hcCartInfoReducer };